import React from "react";
import {Container} from "react-bootstrap";
import {PiEye} from "react-icons/pi";
import NutzungLayout from "../../Components/Nutzung/NutzungLayout.jsx";
import NutzungWidget from "../../Components/Nutzung/NutzungWidget.jsx";
import useNutzungFilter from "../../Components/Nutzung/useNutzungFilter.js";
import useStatisticsData from "../../Components/Statistics/useStatisticsData.js";
import {formatDateTimeDE} from "../../Components/Nutzung/format.js";
import {MitarbeiterLink} from "../../Components/Nutzung/Links.jsx";
import {seitenName} from "../../Components/Nutzung/routeLabels.js";

/**
 * Zugriffsprotokoll auf die Auswertung selbst (Auftrag Teil 7, Endpunkt
 * /nutzung/daten/zugriffe) - wer hat wann in die Nutzungsdaten
 * hineingesehen, auch der Superadmin. Dient als Nachweis, nicht als
 * Kennzahl, deshalb bewusst als schlichte chronologische Liste ohne
 * Diagramm oder Sortierspielereien.
 */
export default function NutzungZugriffe() {
    const nutzungFilters = useNutzungFilter();
    const {filters} = nutzungFilters;
    const {data, loading, error} = useStatisticsData("/nutzung/daten/zugriffe", filters);

    const rows = Array.isArray(data) ? data : [];

    return (
        <Container fluid className="pt-2 pb-4">
            <NutzungLayout gruppe="Verwaltung" titel="Zugriffsprotokoll" nutzungFilters={nutzungFilters}>
                <div className="d-flex align-items-start gap-2 mb-3">
                    <PiEye size={20} className="text-muted flex-shrink-0 mt-1" aria-hidden="true" />
                    <p className="text-muted mb-0">
                        Diese Liste ist der Nachweis, wer wann selbst in die Nutzungsauswertung gesehen hat -
                        jeder Aufruf einer Auswertungsseite wird hier festgehalten, auch der des Superadmins.
                        So bleibt die Auswertung über die Nutzung des Systems selbst nachvollziehbar.
                    </p>
                </div>

                <NutzungWidget
                    title="Aufrufe der Auswertung"
                    loading={loading}
                    error={error}
                    empty={!loading && !error && rows.length === 0}
                    height={280}
                >
                    <ul className="list-unstyled mb-0 d-flex flex-column">
                        {rows.map((zeile, index) => (
                            <li
                                key={`${zeile.zeit}-${zeile.user_id}-${index}`}
                                className={`d-flex align-items-center flex-wrap gap-2 py-2 ${index === 0 ? "" : "border-top"}`}
                            >
                                <span className="small text-muted" style={{minWidth: 140, fontVariantNumeric: "tabular-nums"}}>
                                    {formatDateTimeDE(zeile.zeit)} Uhr
                                </span>
                                <span className="fw-semibold">
                                    <MitarbeiterLink id={zeile.user_id} name={zeile.name} />
                                </span>
                                <span className="text-muted">hat aufgerufen:</span>
                                <span>{seitenName(zeile.seite)}</span>
                            </li>
                        ))}
                    </ul>
                </NutzungWidget>
            </NutzungLayout>
        </Container>
    );
}
